<template>
  <div></div>
</template>
<script>
export default {
  name: 'Transit',
  created() {
    this.getEnterpriseList();
  },
  computed: {},
  methods: {
    getEnterpriseList(search) {
      this.$store
        .dispatch('GetEnterpriseList')
        .then(() => {
          var enterprises = this.$store.getters.user_enterprises;
          if (enterprises.length == 0) {
            this.$router.push({ name: 'enterprise-init', params: {}});
          } else {
            this.$router.push({
              name: enterprises[0].open_market
                ? 'orderManageAll'
                : 'myorderAll',
              params: {
                enterpriseID: enterprises[0].enterprise_id,
                orderState: 'all',
                orderManageType: 'merchants'
              }
            });
          }
        })
        .catch(err => {
          console.log(err);
        });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/views/transit/index.vue